import React, { useMemo } from "react";
import { CampLocation } from "@/types/campLocation";
import { sortCampLocationsByName } from "@/utils/sortCampLocationsByName";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface LocationSelectorProps {
  locations: CampLocation[];
  currentLocationId: string;
  onLocationSelect: (location: CampLocation) => void;
}

const LocationSelector: React.FC<LocationSelectorProps> = ({
  locations,
  currentLocationId,
  onLocationSelect,
}) => {
  const sortedLocations = useMemo(
    () => sortCampLocationsByName(locations || []),
    [locations]
  );

  if (!sortedLocations || sortedLocations.length <= 1) return null;
  
  return (
    <div className="flex items-center gap-2 flex-wrap justify-start mt-2">
      <span className="text-sm text-muted-foreground">Switch location:</span>
      <div className="w-full sm:w-[360px]">
        <Select
          value={currentLocationId}
          onValueChange={(value) => {
            if (value === currentLocationId) return;
            const next = sortedLocations.find(l => l.id === value);
            if (next) onLocationSelect(next);
          }}
        >
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Select a location" />
          </SelectTrigger>
          <SelectContent>
            {sortedLocations.map(loc => (
              <SelectItem key={loc.id} value={loc.id}>
                {loc.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default LocationSelector;
